"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var collection_1 = require("./collection");
var collection_2 = require("../actions/collection");
exports.default = collection_1.default({ name: 'emails', actionTypes: collection_2.create('email').actionTypes });
